<template>
  <div
    class="analytics-container"
    :data-bid="$BID.HOME_ANALYTICS_MV"
    :data-cid="$CID.Home"
  >
    <div class="analytics-header">
      <span class="analytics-title">流量分析</span>
      <span class="analytics-uptime">{{ displayDate }} 更新</span>
      <span
        class="analytics-detail"
        @click="toDetail"
      >详情</span>
    </div>
    <div class="analytics-content">
      <div class="item">
        <div class="title">
          页面访问量/PV
        </div>
        <div class="number">
          {{ data.adv_poi_pv }}
        </div>
        <div class="info">
          <span>较前一天</span>
          <span
            v-if="data.adv_poi_pv_dod >= 0"
            style="color:#009659"
          >+{{ data.adv_poi_pv_dod }}%</span>
          <span
            v-else
            style="color:#F5483B"
          >{{ data.adv_poi_pv_dod }}%</span>
          <span> 较七日前</span>
          <span
            v-if="data.adv_poi_pv_wow >= 0"
            style="color:#009659"
          >+{{ data.adv_poi_pv_wow }}%</span>
          <span
            v-else
            style="color:#F5483B"
          >{{ data.adv_poi_pv_wow }}%</span>
        </div>
      </div>
      <div class="item">
        <div class="title">
          独立访客数/UV
        </div>
        <div class="number">
          {{ data.adv_poi_uv }}
        </div>
        <div class="info">
          <span>较前一天</span>
          <span
            v-if="data.adv_poi_uv_dod >= 0"
            style="color:#009659"
          >+{{ data.adv_poi_uv_dod }}%</span>
          <span
            v-else
            style="color:#F5483B"
          >{{ data.adv_poi_uv_dod }}%</span>
          <span> 较七日前</span>
          <span
            v-if="data.adv_poi_uv_wow >= 0"
            style="color:#009659"
          >+{{ data.adv_poi_uv_wow }}%</span>
          <span
            v-else
            style="color:#F5483B"
          >{{ data.adv_poi_uv_wow }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingApi from '@/api/marketing';
import tracker from '@/util/tracker';

export default {
  name: 'AnalyticsInHome',
  data() {
    return {
      data: {
        'dt:dt': '',
        adv_poi_pv: 0,
        adv_poi_uv: 0,
        adv_poi_pv_dod: 0,
        adv_poi_uv_dod: 0,
        adv_poi_pv_wow: 0,
        adv_poi_uv_wow: 0,
      },
      date: new Date(Date.now() - 8.64e7), // 时间挪到昨天
      displayDate: '',
    };
  },
  created() {
    this.displayDate = `${this.date.getMonth() + 1}/${this.date.getDate()}`;
    this.getData();
  },
  methods: {
    dateBeginTime(date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date.getTime();
    },
    dateEndTime(date) {
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      date.setMilliseconds(0);
      return date.getTime();
    },
    async getData() {
      const { data } = await MarketingApi.getData();
      if (data.length) {
        /**
         * 返回数据格式示例
            {
              labels: ['dt:dt', 'pv', 'uv'],
              values: [['20230201', '100', '100']]
            }
         */
        const { labels = [], values = [] } = data[0] || {};
        const [records = []] = values;
        labels.forEach((item, index) => {
          if (item in this.data) {
            this.data[item] = Number(records[index]) || 0;
          }
        });
      }
    },
    toDetail() {
      this.$router.push('/analytics/detail');
      tracker.sendModuleClick(this.$BID.HOME_ANALYTICS_MC, null, { cid: this.$CID.Home });
    },
  },
};
</script>

<style lang="scss" scoped>
.analytics-container {
  margin: 18px;
  padding: 0 36px;
  background: #fff;
  border-radius: 12px;
  padding: 30px 36px 36px;
}
.analytics-header{
  margin-bottom: 20px;
  text-align: left;
}
.analytics-title{
  font-size: 32px;
  font-weight: bold;
}
.analytics-uptime{
  font-size: 22px;
  color: #999;
  margin: 0 12px;
}
.analytics-detail{
  font-size: 26px;
  position: relative;
  float: right;
  margin-right: 20px;
  color: #666;
  &::before{
    content: " ";
    display: inline-block;
    height: 16px;
    width: 16px;
    border: 2px solid #1a1a1a;
    border-left: 0;
    border-bottom: 0;
    position: absolute;
    top: 12px;
    left: 52px;
    transform: rotate(45deg);
  }
}
.analytics-content {
  display: flex;
  justify-content: space-between;
  .item {
    text-align: left;
    flex: 1;
    .title,.info {
      color: #666666;
      font-size: 22px;
    }
    .number {
      font-family: PingFangSC-Medium;
      font-size: 36px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: 0px;
      color: #222222;
      margin: 20px 0;
    }
  }
}
</style>
